module.exports = "<hybse-admin-create-locale [actionType]=\"'edit'\">\n  \n</hybse-admin-create-locale>"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/locale/update-locale/update-locale.component.html
// module id = ../../../../../src/app/components/pages/locale/update-locale/update-locale.component.html
// module chunks = main